module.exports = __webpack_public_path__ + "img/img70.e7badfb8.svg";